export default [
  {
    title: 'Ongi etorri',
    element: 'body',
    text: 'Ongi etorri Idoniara, zure irudiak trukatzeko plataformara. Tour honetan erabiltzen ikasten lagunduko dizugu.',
    placement: {
      relativeTo: 'viewport',
      position: 'bottom right'
    }
  },
  {
    title: 'Nire gunea',
    element: '.file-container',
    text: '"Nire gunea" esparruan Idonian dituzun karpeta, dokumentu eta azterketa guztiak ikusi ahal izango dituzu. Eraman hona Idonian gorde nahi dituzun karpetak edo fitxategiak.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: '"Berria" botoia',
    element: 'button.new',
    text: 'Erabili menu hau edukien karpeta bat sortzeko, fitxategi bat edo zure gailuaren karpetak igotzeko. DICOM azterketa oso bat ere igo dezakezu ikusteko.',
    placement: {
      relativeTo: 'element',
      position: 'left top'
    }
  },
  {
    title: 'Partekatutako fitxategiak',
    element: 'a[data-name="shared"]',
    text: '"Nirekin partekatuta" atalean, SERAMek zurekin partekatu dituen kasuak ikusi ahal izango dituzu, baita beste erabiltzaile batzuek partekatutako beste fitxategi eta karpeta batzuk ere.',
    placement: {
      relativeTo: 'element',
      position: 'right bottom'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/eu-ES/seram2018.js